import { TemplatePage } from './types';

const marketingPage: TemplatePage = {
  header: {
    color: '#F8CE68',
    icon: 'images/video-templates/industry-marketing.jpg',
    title: 'Marketing Video Templates Collection',
    title_meta: '500+ Free Marketing Video Templates',
    description_meta:
      'Boost your digital marketing campaigns with Wave.video’s 500+ customizable marketing video templates perfect for ' +
      'any business.',
    description:
      'Boost your digital marketing campaigns with 500+ customizable marketing video templates perfect for any business. ' +
      'Creating engaging videos that your customers won’t want to skip has never been easier!'
  },
  footer: {
    category: 'Marketing',
    description:
      'Wave.video’s impressive collection of editable marketing video templates makes it simple to create compelling ' +
      'videos for any purpose. All the templates are free and easy to customize to suit every brand and topic.'
  },
  content: [
    {
      type: 'templates',
      title: 'marketing templates',
      search: { name: 'marketing' }
    },
    {
      type: 'stocks',
      title: 'marketing',
      search: { name: 'marketing' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default marketingPage;
